import { computed, Signal } from '@angular/core';
import { SecurityMetadata } from '../../abstractions/security-metadata';
import { TaxResultItemField } from './tax-result-item-field';

export class SecurityTaxResultItemForm {
  questionText!: string;
  yesNoValue!: boolean;
  isUnsure!: boolean;
  metadata!: SecurityMetadata;
  uuid!: string;
  rate?: TaxResultItemField;
  explanation?: TaxResultItemField;

  isInvalid: Signal<boolean> = computed((): boolean => {
    return (
      !!(this.explanation && this.explanation.isInvalid()) ||
      !!(this.rate && this.rate.isInvalid())
    );
  });

  hasChanges: Signal<boolean> = computed(() => {
    return (
      !!(this.explanation && this.explanation.hasChanges()) ||
      !!(this.rate && this.rate.hasChanges())
    );
  });

  hasDuplicatedValues: Signal<boolean> = computed((): boolean => {
    return (
      !!(this.explanation && this.explanation.hasDuplicatedValue()) ||
      !!(this.rate && this.rate.hasDuplicatedValue())
    );
  });
}
